// extracted by mini-css-extract-plugin
export var grid = "_19-0";
export var span1 = "_19-2";
export var span10 = "_19-b";
export var span10L = "_19-z";
export var span10M = "_19-n";
export var span10Xl = "_19-1b";
export var span11 = "_19-c";
export var span11L = "_19-10";
export var span11M = "_19-o";
export var span11Xl = "_19-1c";
export var span12 = "_19-d";
export var span12L = "_19-11";
export var span12M = "_19-p";
export var span12Xl = "_19-1d";
export var span1L = "_19-q";
export var span1M = "_19-e";
export var span1Xl = "_19-12";
export var span2 = "_19-3";
export var span2L = "_19-r";
export var span2M = "_19-f";
export var span2Xl = "_19-13";
export var span3 = "_19-4";
export var span3L = "_19-s";
export var span3M = "_19-g";
export var span3Xl = "_19-14";
export var span4 = "_19-5";
export var span4L = "_19-t";
export var span4M = "_19-h";
export var span4Xl = "_19-15";
export var span5 = "_19-6";
export var span5L = "_19-u";
export var span5M = "_19-i";
export var span5Xl = "_19-16";
export var span6 = "_19-7";
export var span6L = "_19-v";
export var span6M = "_19-j";
export var span6Xl = "_19-17";
export var span7 = "_19-8";
export var span7L = "_19-w";
export var span7M = "_19-k";
export var span7Xl = "_19-18";
export var span8 = "_19-9";
export var span8L = "_19-x";
export var span8M = "_19-l";
export var span8Xl = "_19-19";
export var span9 = "_19-a";
export var span9L = "_19-y";
export var span9M = "_19-m";
export var span9Xl = "_19-1a";
export var stretch = "_19-1";